import * as React from 'react';
import { DatePicker } from 'antd';
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { IWidget } from 'common/schema/widget/Widget';
import { getWidgetInputText } from '../helper/getWidgetInputText';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { DatePickerInput } from 'client/ui/form/input/DatePickerInput';
import { useFormWidgetProps } from './contextual/useFormWidgetProps';

export interface FormWidgetInputDateViewProps {
  widget: IWidget;
}

export function FormWidgetInputDateView(props: FormWidgetInputDateViewProps) {
  const { widget } = props;

  // Abbiamo un singolo metadato
  const metadata = MetadataLogic.singleFromWidget(widget);
  const name = `values.${metadata.id}`;

  const [inputProps] = useFormWidgetProps(widget);

  return (
    <FormWidgetItem name={name} widget={props.widget}>
      <DatePickerInput
        type="from"
        name={name}
        placeholder={widget.input?.placeholder}
        style={{ width: '100%' }}
        {...inputProps}
      />
    </FormWidgetItem>
  );
}
